<template>
  <el-dialog :visible.sync="postDeleteVisible"
             title="删除岗位">
    <div>{{canNotDelete === false ? '确定删除该岗位设置吗？' : '该岗位有员工，请先移除员工再删除'}}</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="canNotDelete === true ? (postDeleteVisible = false) : deleteHandle()">确 定</el-button>
      <el-button @click="postDeleteVisible = false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      postDeleteVisible: false,
      dataListLoading: false,
      postId: '',
      canNotDelete: false // true:有 false:没有
    }
  },
  methods: {
    init () {
      this.postDeleteVisible = true
      this.canNotDelete = false
      this.$nextTick(() => {
        if (this.postId) {
          this.getPostUser()
        }
      })
    },
    // 查询当前岗位下是否有员工
    getPostUser () {
      this.dataListLoading = true
      this.$http.get(`/front/consumer/custorg/getPostEmployeeCount/${this.postId}`)
        .then(({ data: res }) => {
          this.dataListLoading = false
          this.canNotDelete = res.data
        }).catch(() => {
          this.dataListLoading = false
        })
    },
    // 删除
    deleteHandle () {
      if (this.dataListLoading) {
        return true
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/custorg/deletePost`, { postId: this.postId })
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code === 0) {
            this.postDeleteVisible = false
            this.$emit('refreshDataList')
          }
        }).catch(() => {
          this.dataListLoading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
